import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "add-to-cart" }
const _hoisted_2 = {
  key: 0,
  class: "add-to-cart__header"
}
const _hoisted_3 = { class: "add-to-cart__content-wrap" }
const _hoisted_4 = { class: "add-to-cart__label" }
const _hoisted_5 = { class: "add-to-cart__bottom" }
const _hoisted_6 = { class: "add-to-cart__total" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["disabled"]

import { ref, computed, watch, onMounted, nextTick } from 'vue';

import useContext from '@/composables/useContext';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import useStock from '@/composables/useStock';
import { useCartFunctions } from '@/helpers/cart-actions';
import useVariantPrices from '@/composables/useVariantPrices';

import QuantityInput from './QuantityInput.vue';
import Skeleton from './Skeleton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddToCart',
  props: {
  title: {
    type: String,
    default: '',
  },
  selectedQuantity: {
    type: Number,
    default: 1,
  },
  productData: {
    type: Object,
  },
  selectedVariant: {
    type: Object,
  },
  price: {
    type: Number,
  },
  isBusy: {
    type: Boolean,
    default: false,
  },
},
  emits: ['added-to-cart', 'quantityChanged'],
  setup(__props, { emit }) {

const props = __props;

const { formatPrice } = useContext();
const { getAllStockItems, getCanBeOrderedFromSupplier } = useStock();
const { websiteText } = useWebsiteTexts();
const { addToCart } = useCartFunctions();





const quantityInput: any = ref(null);
const quantity = ref(+props.selectedQuantity || 0);
const error = ref('');
const message = ref('');

const unitOfMeasurement = computed(() => {
  return (
    props.selectedVariant?.unitOfMeasurement ||
    props.productData?.fieldsJson?.unitOfMeasurement ||
    websiteText('product__stockstatus__units').value?.toLowerCase() ||
    'product__stockstatus__units'
  );
});

const packagingInfo = computed(() => {
  return props.selectedVariant?.packaging?.caption || '';
});

const selectedVariant = computed(() => {
  return props.selectedVariant;
});

const { unitPrice, campaignPrice, isBusy } = useVariantPrices(
  selectedVariant,
  quantity
);

const totalPrice = computed(
  () => (campaignPrice.value || unitPrice.value) * quantity.value
);

const allStockItems = computed(() =>
  getAllStockItems({
    variant: selectedVariant.value,
    quantity: quantity.value,
    subtractQuantityFromCart: true,
  })
);

const totalStockAvailable = computed(() => {
  return props.selectedVariant?.stock?.totalStockAvailable || 0;
});

const canBeOrderedFromSupplier = computed(() =>
  getCanBeOrderedFromSupplier(props.selectedVariant)
);

const quantityMultiplier = computed(() => {
  return (
    props.selectedVariant?.purchaseQuantityFactor ||
    props.productData?.purchaseQuantityMultiplier ||
    1
  );
});

watch(
  () => props.selectedQuantity,
  (val) => {
    quantity.value = val;
    quantityInput.value?.setAmount(quantity.value);
  }
);

watch(
  () => quantity.value,
  () => {
    if (
      quantity.value > totalStockAvailable.value &&
      !canBeOrderedFromSupplier.value
    ) {
      quantity.value = totalStockAvailable.value;
      quantityInput.value?.setAmount(quantity.value);
    }

    var remainder = quantity.value % quantityMultiplier.value;
    if (remainder != 0) {
      quantity.value -= remainder;
      quantityInput.value.setAmount(quantity.value);
    }
  }
);

async function onAddToCartClick() {
  try {
    const row = await addToCart(props.selectedVariant, quantity.value);
    emit('added-to-cart', row?.id || null);
  } catch (err: any) {
    error.value = err;
  }
}

onMounted(() => {
  if (quantityMultiplier.value !== 1) {
    message.value = websiteText('product__quantity_factor', {
      amount: quantityMultiplier.value,
    }).value;

    nextTick(() => quantityInput.value.setMessage(message.value));
    quantity.value = quantityMultiplier.value;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(websiteText)('global__quantity').value) + ": ", 1),
        _createVNode(QuantityInput, {
          quantity: _unref(quantityMultiplier),
          unitOfMeasurement: _unref(unitOfMeasurement),
          "stock-items": _unref(allStockItems),
          "narrow-style": true,
          "pack-quantity": _unref(quantityMultiplier),
          "packaging-info": _unref(packagingInfo),
          error: error.value,
          "onUpdate:quantity": _cache[0] || (_cache[0] = ($event: any) => (quantity.value = $event)),
          ref_key: "quantityInput",
          ref: quantityInput
        }, null, 8, ["quantity", "unitOfMeasurement", "stock-items", "pack-quantity", "packaging-info", "error"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, _toDisplayString(_unref(websiteText)('cart__total').value), 1),
        (!_unref(isBusy))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(formatPrice)(_unref(totalPrice))), 1))
          : (_openBlock(), _createBlock(Skeleton, {
              key: 1,
              class: "add-to-cart__price-skeleton"
            }))
      ]),
      _createElementVNode("button", {
        class: "secondary-button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (onAddToCartClick())),
        disabled: quantity.value === 0 || _unref(isBusy)
      }, _toDisplayString(_unref(websiteText)('global__add_to_cart').value), 9, _hoisted_8)
    ])
  ]))
}
}

})